module.exports = __webpack_public_path__ + "23be93578ce7e4a185167a5568e0927b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-anahuac.png
// module id = 101
// module chunks = 0